const { default: axios } = require("axios");

Alpine.data('TagifyInput', () => ({
    loading: false,
    tagify: null,
    init() {
        var self = this
        self.$nextTick(() => {
            var inputElm = document.getElementById('company_name');
            if (inputElm) {
                inputElm?.setAttribute('aria-label', 'Property tags');
                inputElm?.setAttribute('aria-labelledby', 'property-tags-label');
            }
            self.tagify = new Tagify(inputElm, {
                enforceWhitelist: false,
                mode: "select",
                skipInvalid: false,
                editTags: false,
                whitelist: inputElm?.value.trim().split(/\s*,\s*/),
                templates: {
                    dropdownItemNoMatch: function (data) {
                        return `No developer found press enter to add: ${data.value}`
                    }
                },
            })

            function debounce(func, delay) {
                let timeoutId;
                return function () {
                    const context = this;
                    const args = arguments;
                    clearTimeout(timeoutId);
                    timeoutId = setTimeout(function () {
                        func.apply(context, args);
                    }, delay);
                };
            }

            self.tagify
                .on('add', onAddTag)
                .on('remove', onRemoveTag)
                .on('input', debounce(onInput, 250))
                .on('invalid', onInvalidTag)
                .on('focus', onTagifyFocusBlur)
                .on('blur', onTagifyFocusBlur)
                .on('dropdown:hide dropdown:show', e => togglePlaceholder())
                .on('dropdown:select', onDropdownSelect)

            function togglePlaceholder(e) { }
            function onAddTag(e) {

                // triggerEvent(e);

                // var event = new CustomEvent('select', e);
                // window.dispatchEvent(event);
            }
            function onRemoveTag(e) {
                self.tagify.whitelist = [];
                self.tagify.loading(false)

                triggerEvent({ data: null });
            }
            function triggerEvent(data = null) {
                window.dispatchEvent(
                    new CustomEvent('tagify-selected', {
                        detail: data
                    })
                );
            }

            function onInput(e) {
                self.tagify.whitelist = null;
                self.tagify.loading(false);
                var term = e.detail.value;
                if (term == '') {
                    self.tagify.whitelist = [];
                    self.tagify.loading(false);
                    triggerEvent({ data: null });


                    return;
                }
                axios.get('/api/local/developers', {
                    params: {
                        term: term,
                        q: term,
                        fields: ['country_id', 'state_id', 'city_name', 'website_url', 'office_address'],
                        // ignore_type: 'developer',
                        countryId: window.global.country_id
                    }
                })
                    .then(function (result) {
                        var data = result.data.results.map(item => {
                            item.value = `${item.text}`;
                            return item;
                        });
                        if (data.length === 0) {
                            self.tagify.settings.whitelist = [];
                            const customEntry = { value: term, text: term };
                            data = [customEntry];
                            self.tagify.settings.whitelist = data.concat(self.tagify.value);
                        } else {
                            self.tagify.settings.whitelist = data.concat(self.tagify.value);
                            self.tagify.loading(false).dropdown.show(e.detail.value);
                        }
                    })
                    .catch(err => self.tagify.dropdown.hide());
            }
            function onInvalidTag(e) { console.log(e.detail.data); }
            function onTagifyFocusBlur(e) { console.log(e.type, "event fired") }
            async function onDropdownSelect(e) {
                triggerEvent(e.detail);
            }
        });
    },
}));


Alpine.data('PricingFaqs', (props) => ({
    toggle(index) {
        this.faqs[index].open = !this.faqs[index].open
    },
    billingTab: 'annual',
    faqs: [
        {
            question: "Can real estate brokers advertise on XPLOON?",
            answer: "No. One of the key aspects that makes XPLOON a one-of-a-kind platform is its exclusivity to real estate developers. While traditional advertising channels allow real estate brokers, agents, homeowners, and individuals to advertise all kinds of properties, XPLOON is dedicated to providing exclusive opportunities to only real estate developers.",
            open: false
        },
        {
            question: "Does XPLOON charge any fees from the customers?",
            answer: "No, cutting out the middleman, XPLOON connects customers directly with real estate developers because of our eligibility criteria. Buyers can experience a seamless and transparent process as they interact directly with real estate developers, ensuring a hassle-free buying experience.",
            open: false
        },
        {
            question: "Can individual property sellers list their properties on XPLOON?",
            answer: "No. With a strict vetting process, XPLOON ensures that only licensed real estate developers have access to our platform. By providing exclusive opportunities, XPLOON is not only benefiting real estate developers but also enhancing the overall experience for buyers searching for a brand new home in the UAE.",
            open: false
        },
        {
            question: "Is it possible for developers to integrate their property listings with XPLOON?",
            answer: "Yes. You can link your CRM system or XML feed with XPLOON effortlessly. No more hassle of manual data entry or synchronization. Stay organized and streamline your workflow with our seamless integration.",
            open: false
        },
        {
            question: "How much commission is deducted from each sale on XPLOON?",
            answer: "XPLOON is created as a unique advertising portal to connect buyers with developers. We do charge a service fee from developers for advertising their listings on our platform. However, there is no additional commission or fee on sales charged from real estate developers. That means regardless of the volume of sales you generate by advertising on XPLOON, you retain 100% of sales revenue. Our platform connects home buyers directly with developers to eliminate the need for any middlemen or extra charges.",
            open: false
        },
        {
            question: "How many projects can I advertise on XPLOON?",
            answer: "Developers can advertise unlimited projects on XPLOON, regardless of their subscription plan.",
            open: false
        },
        {
            question: "How many listings can I advertise on XPLOON?",
            answer: "Developers can advertise up to 100 listings on XPLOON, regardless of their subscription plan.",
            open: false
        },
        {
            question: "Can I purchase additional Basic, Silver, or Gold listings?",
            answer: "Yes. If you have reached the listing limit included in your package, you can purchase additional Basic, Silver, or Gold listings separately through your dashboard without upgrading your subscription plan. This gives you the flexibility to advertise more properties and projects while keeping your existing package.",
            open: false
        },
        {
            question: "When will my additional listings expire?",
            answer: "Additional listings expire at the same time as your subscription plan. Any unused or active additional listings will remain valid until your subscription reaches its expiry date.",
            open: false
        },
        {
            question: "What happens when my package expires?",
            answer: "When your subscription package expires, your listings may be paused or removed from public visibility. To keep your listings active and visible to buyers, you will need to renew your subscription.",
            open: false
        },
        {
            question: "How quickly will my project go live?",
            answer: "Projects are typically published shortly after verification and approval. Once your submission has been reviewed and approved, it will be made live on the platform and visible to buyers.",
            open: false
        },
        {
            question: "Are my contact details visible to buyers?",
            answer: "Yes. Buyers can contact you directly through the contact channels, such as phone, WhatsApp, email, and inquiry forms. This enables direct communication between buyers and developers without the need for intermediaries.",
            open: false
        },
        {
            question: "Can I upload project images, brochures, and floor plans?",
            answer: "Yes. All subscription packages allow you to upload and showcase project images, brochures, floor plans, and other marketing materials to help buyers better understand your development and make informed decisions.",
            open: false
        },
        {
            question: "Can I delete a published listing and replace it with a new listing within my package limit?",
            answer: "Yes. You can delete a published listing and use the freed-up slot to publish a different listing, provided you remain within your package's total listing allowance. This gives you the flexibility to update and manage your portfolio as your inventory changes.",
            open: false
        },
        {
            question: "Can I edit the project information?",
            answer: "Yes. If you are the original creator of the project, you can directly edit the project information. If you are not the creator, you will need to submit an update request. Our team will review the request, and if approved, an admin user will update the project details on your behalf.",
            open: false
        },
        {
            question: "Do reviews affect search ranking?",
            answer: "Yes. Listings with higher ratings and more positive reviews generally achieve better visibility and performance in search results compared to listings with fewer or no reviews.",
            open: false
        },
        {
            question: "Can I cancel my subscription on XPLOON?",
            answer: "Yes, you can cancel your subscription at any time. However, you will still be charged for the full duration of your contract, and your subscription will remain active until the end of the agreed billing period.",
            open: false
        },
        {
            question: "Can I downgrade my subscription?",
            answer: "Yes, you can downgrade your subscription at the end of your current billing period. You can manage and request the downgrade directly through your account dashboard.",
            open: false
        },
        {
            question: "Can I upgrade my existing subscription?",
            answer: "Yes, you can upgrade your subscription at any time during your active billing cycle. You can upgrade immediately, without waiting for your renewal date. Any unused time from your current plan may be adjusted on a pro-rata basis, depending on the upgrade.",
            open: false
        },
        {
            question: "If I change my developer company, can I continue using the same subscription?",
            answer: "Yes, but this requires a formal request. If the subscription is billed under your name, you may continue using the same subscription. However, the XPLOON support/admin team will need to review and approve the change by verifying the updated company association. You must also submit a new work email as part of the verification process.",
            open: false
        },
        {
            question: "Will I have access to my old developer projects and listings?",
            answer: "No. You will not have access to your old developer projects and listings once you are no longer associated with that company, as access is restricted based on your current active work association.",
            open: false
        },
        {
            question: "If I am using access given by my company through an enterprise account, will I have access to leads after leaving the company?",
            answer: "No. If you are using an enterprise account provided by your company, you will not have access to leads once you leave the company, as access is tied to the organisation's account and permissions.",
            open: false
        },



    ],
}));
Alpine.data('AboutFaqs', (props) => ({
    toggle(index) {
        this.faqs[index].open = !this.faqs[index].open
    },
    faqs: [
        {
            question: "What is Xploon?",
            answer: "XPLOON is a one-of-a-kind real estate portal that connects home buyers directly with real estate developers. The idea behind the creation of this portal is to allow buyers to find the brand new home of their dreams while prioritizing transparency, authenticity, and of course, ease.",
            open: false
        },
        {
            question: "How is Xploon different from other portals?",
            answer: "Unlike traditional real estate portals, Xploon focuses on direct contact with developer portals. We stand out by offering direct communication with sellers for developers, ensuring that our users get the best value, transparency, and support in the market.",
            open: false
        },
        {
            question: "Is there any fee when buying through xploon?",
            answer: "No, buying through Xploon is completely free for buyers! We pride ourselves on transparent pricing added by developers with absolutely zero hidden fees or commissions added to your purchase. Since there in no fee or commission for both buyers and developers.",
            open: false
        },
        {
            question: "Is Xploon available as a mobile app?",
            answer: "Yes! You can access all of Xploon’s features on the go. The official Xploon mobile app is available for free download on both the Apple App Store (iOS) and Google Play Store (Android). Download the app today.",
            open: false
        },
    ],
}));

Alpine.data('XLoader', (props) => ({
    show: props.show ?? false,
    displayLabel: props.displayLabel,
    isCard: props.isCard,
    type: props.type ?? 'form',
    wrapperClass: props.wrapperClass,
    init() {
        const _self = this;
        _self.$nextTick(() => {

        })

        window.addEventListener('isLoading', (event) => {
            const detail = event.detail;
            _self.displayLabel = detail.label;
            _self.isCard = detail.type == 'card';
            _self.show = detail.loading;
        });
    },
    handleLoader(options) {
        this.show = true;
    }
}));

Alpine.data('Pricing', (props) => ({
    open: 'yearly',
    monthly: false,
    countries: [],
    states: [],
    stripe: null,
    cardElement: null,
    cardElementError: '',
    cities: [],
    currentStep: 0,
    paymentMethod: 'card',
    paymentCycle: props.billingCycle,
    plan: props.plan,
    total_first_price: props.total_first_price,
    currency: props.currency,
    referral: props.referral ?? false,
    coupon: props.coupon,
    tax: props.tax,
    validator: null,
    steps: ['Step 1', 'Step 2', 'Step 3'],
    submitted: false,
    isLoading: false,
    loadingSendCode: false,
    showCodeInput: false,
    // ── TASK 3: countdown for resend ─────────────────────────
    verifyCountdown: 0,
    _countdownTimer: null,
    // ── TASK 5.2: store user id for application reference ────
    submittedUserId: null,
    submittedUserFormattedId: null,
    cardConfirmed: false,
    showSplit: false,
    payment_method_id: '',

    selectCycle(type) {
        this.paymentCycle = type;
    },

    get priceMonthly() {
        return this.isSplit ? this.plan.split_price_monthly : this.plan.price_monthly;
    },
    get discountPercentage() {
        return Math.round(100 - ((this.plan.price_monthly / this.plan.split_price_monthly) * 100));
    },

    get isSplit() {
        return this.paymentCycle === 'split';
    },
    
    get contractMonthsFormatted() {
        return this.plan.contract_months - (this.plan.has_free_trial ? this.plan.free_trial_months : 0);
    },

    get paidMonthsSubtotal() {
        if (this.plan.has_free_trial) {
            return this.priceMonthly * (this.plan.contract_months - this.contractMonthsFormatted);
        }
        return this.priceMonthly * this.plan.paid_months;
    },

    get currentDiscount() {
        if (this.plan.has_free_trial) {
            return this.priceMonthly * this.plan.free_trial_months;
        }
        return this.priceMonthly * this.plan.free_months;
    },

    get referralDiscount() {
        if (!this.referral) return 0;
        return this.coupon.type === 'fixed'
            ? this.coupon.amount_off / 100
            : this.paidMonthsSubtotal * this.coupon.amount_off / 100;
    },

    get subTotal() {
        return this.paidMonthsSubtotal;
    },

    get total() {
        return this.paidMonthsSubtotal - this.referralDiscount;
    },

    get totalTax() {
        return this.total * (this.tax.percentage / 100);
    },

    get totalPlanPrice() {
        return this.priceMonthly * this.plan.contract_months;
    },

    get perMonthPrice() {
        const totalWithTax = this.total + this.totalTax;
        
        if (this.isSplit) {
            return totalWithTax / this.contractMonthsFormatted;
        }

        return totalWithTax;
    },

    get todaysTotal() {
        // if (this.plan.has_free_trial) {
        //     return 0;
        // }
        return this.perMonthPrice.toFixed(2);
    },

    get splitPriceArray() {
        if (!this.isSplit) return [];

        const startDate = new Date();

        const sixMonths = this.plan.free_trial_months;
        return Array.from({ length: this.plan.contract_months -(this.plan.has_free_trial ? sixMonths : 0 ) }, (_, i) => {
            const paymentDate = new Date(startDate);
            paymentDate.setMonth((startDate.getMonth() + sixMonths) + i);

            const isToday = paymentDate.toDateString() === startDate.toDateString();
            const _date = paymentDate.toISOString().split('T')[0];
            
            return {
                month: i + 1,
                only_date: _date,
                referralDiscount: this.referralDiscount / this.plan.contract_months,
                tax: this.totalTax / this.plan.contract_months,
                freeMonthDiscount: this.currentDiscount / this.plan.contract_months,
                date: isToday ? 'Today' : _date,
                full_date: paymentDate.toISOString(),
                amount: this.currency + this.perMonthPrice.toFixed(2),
                amountWithoutCurrency: this.perMonthPrice.toFixed(2),
            };
        });
    },

    formData: {
        // step 1
        first_name: '',
        last_name: '',
        business_email: '',
        email_code: '',
        is_valid_email_code: '',
        // step 2
        password: '',
        password_confirmation: '',
        resident_ids: [],
        company_name: '',
        company_website: '',
        country_id: '',
        state_id: '',
        city_name: '',
        office_address: '',
        // step 3
        card_name: '',
        address_line1: '',
        address_city: '',
        address_country: '',
        confirm_consent_employee: '',
        confirm_terms_condition: ''
    },

    getStepTitle() {
        if (this.currentStep === 0) return "Create Your Account";
        if (this.currentStep === 1) return "Company Information";
        if (this.currentStep === 2) return "Payment Details";
    },

    getStepSubtitle() {
        if (this.currentStep === 0) return "";

        const name = `${this.formData.first_name} ${this.formData.last_name}`.trim();
        const email = this.formData.business_email;

        return `${name} • ${email}`;
    },
    goDashboard() {
        this.currentStep = 0;
        setTimeout(() => {
            this.submitted = false;
            this.isLoading = false;
            document.querySelector('[data-loader]')._x_dataStack[0].show = false;
            this.showCodeInput = false;
            this.submittedUserId = null;
            this.submittedUserFormattedId = null;
            this.formData.is_valid_email_code = '';
        }, 0);
    },

    validateStep() {
        let valid = true;
        const currentStepEl = $(this.$refs.signupAgent).find(`[data-step="${this.currentStep}"]`);
        currentStepEl.find(':input').each(function () {
            if (!$(this).valid()) {
                valid = false;
            }
        });
        return valid;
    },

    next() {
        if (!this.validateStep()) {
            return;
        }

        // Step 1: need verified email before proceeding
        if (this.currentStep == 0) {
            if (!this.showCodeInput) {
                this.getCode();
                return;
            }
            // Has code input shown but email not yet verified — block
            if (this.formData.is_valid_email_code !== 'true') {
                return;
            }
        }

        if (this.currentStep < this.steps.length - 1) {
            this.currentStep++;
            $("html, body").animate({
                scrollTop: $("#top_tab").offset().top - 210
            }, 200);
        } else {
            $(this.$refs.signupAgent).submit();
        }
    },

    prev() {
        if (this.currentStep > 0) {
            this.currentStep--;
        }
    },

    // ── TASK 3: getCode starts the 10-second countdown ──────────────
    async getCode() {


        if (this.validator.invalid.business_email) {
            if (!this.validateStep()) {
                return;
            }
        }
        this.loadingSendCode = true;
        this.loader(true, 'form', 'Sending code… Check your email.');
        this.showCodeInput = false;
        try {
            const res = await axios.post(`/${window.global.country_code}/send-code`, this.formData);
            if (res.data.success) {
                this.showCodeInput = true;
                this._startCountdown(10);
            }
        } catch (error) {
            console.log(error, 'error');
        } finally {
            this.loadingSendCode = false;
            this.loader(false);
        }
    },

    loader(show, type = 'form', label = "Processing...") {
        var event = new CustomEvent('isLoading', {
            detail: {
                label: label,
                type: type,
                loading: show
            }
        });
        window.dispatchEvent(event);
    },

    _startCountdown(seconds) {
        this.verifyCountdown = seconds;
        if (this._countdownTimer) clearInterval(this._countdownTimer);
        this._countdownTimer = setInterval(() => {
            this.verifyCountdown--;
            if (this.verifyCountdown <= 0) {
                this.verifyCountdown = 0;
                clearInterval(this._countdownTimer);
            }
        }, 1000);
    },

    verifyCode() {
        axios.post(`/${window.global.country_code}/verify-code`, {
            business_email: this.formData.business_email,
            email_code: this.formData.email_code,
        }).then((res) => {
            if (res.data.success && !this.formData.is_valid_email_code) {
                this.formData.is_valid_email_code = 'true';
            } else {
                this.formData.is_valid_email_code = '';
            }
        }).catch(error => {
            console.log(error, 'error');
        });
    },

    showDeveloperFields: true,

    form: {
        country_id: '',
        state_id: '',
        city_name: '',
        website_url: '',
        office_address: '',
    },
    locked: {
        country_id: false,
        state_id: false,
        city_name: false,
        website_url: false,
        office_address: false,
    },
    async handleTagify(e) {
        if (e.detail && e.detail.data && 'id' in e.detail.data) {

            // 1. Fetch states FIRST and wait for it to fully complete
            await this.fetchStates(e.detail.data.country_id);

            // 2. Wait for Vue to render the new state options into the DOM
            await this.$nextTick();

            // 3. NOW assign the form data (state_id will find its matching option)
            this.form = { ...e.detail.data };

            this.locked = {
                website_url: !!e.detail.data.website_url,
                country_id: !!e.detail.data.country_id,
                state_id: !!e.detail.data.state_id,
                city_name: !!e.detail.data.city_name,
                office_address: !!e.detail.data.office_address,
            };

            // 4. Wait again for Vue to reflect the form values in the DOM
            await this.$nextTick();

            validateByField('#create-agent-account', 'company_website');
            validateByField('#create-agent-account', 'country_id');
            validateByField('#create-agent-account', 'state_id');
            validateByField('#create-agent-account', 'city_name');
            validateByField('#create-agent-account', 'office_address');
            validateByField('#create-agent-account', 'company_name');

        } else {

            this.form = {
                id: null,
                country_id: '',
                state_id: '',
                city_name: '',
                website_url: '',
                office_address: '',
            };

            this.locked = {
                website_url: false,
                country_id: false,
                state_id: false,
                city_name: false,
                office_address: false,
            };

            await this.$nextTick();

            validateByField('#create-agent-account', 'company_website');
            validateByField('#create-agent-account', 'country_id');
            validateByField('#create-agent-account', 'state_id');
            validateByField('#create-agent-account', 'city_name');
            validateByField('#create-agent-account', 'office_address');
            validateByField('#create-agent-account', 'company_name');

        }
    },

    async init() {
        const _self = this;

        this.$watch('formData.email_code', (email_code) => {
            if (email_code.length == 6) {
                this.verifyCode();
            }
        });

        this.stripe = Stripe(props.apiSecret);

        const elements = this.stripe.elements();

        this.cardElement = elements.create('card', {
            hidePostalCode: true,
            disableLink: true,
        });

        this.cardElement.mount('#card-element');

        this.cardElement.on('change', async (event) => {
            $('input[name="cardElementField"]').empty().val(event.complete ? event.complete : '');
            $(this.$refs.signupAgent)
                .validate()
                .element('[name="cardElementField"]');
            if (event.complete) {
                this.cardElementError = '';
            } else {
                this.cardElementError = event?.error ? (event?.error?.message) : '';
            }
        });

        $.ajaxSetup({
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') }
        });

        $.validator.addMethod("passwordPattern", function (value, element) {
            return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).*$/.test(value);
        }, "Password must contain uppercase, number and lowercase letters");

        $.validator.addMethod("validNamePattern", function (value, element) {
            return /^[a-zA-Z0-9\s]+$/.test(value);
        }, "Letters and numbers only");

        $.validator.addMethod("validWebsitePattern", function (value, element) {
            if (this.optional(element)) {
                return true;
            }

            const regex = /^(https?:\/\/)?(www\.)?[a-z0-9.-]+\.[a-z]{2,}(\/\S*)?$/i;

            return regex.test(value);
        }, "Website must be a valid URL and must not contain spaces");

        $.validator.addMethod("email_code_success", function (value, element) {
            return _self.formData.is_valid_email_code == 'true';
        }, "Code you entered is incorrect or invalid");

        $.validator.addMethod("validEmailPattern", function (value, element) {
            return /^[a-zA-Z0-9._]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
        }, "Please enter valid email");

        $.validator.addMethod("maxFileSize", function (value, element, params) {
            const files = element.files;

            if (!files || files.length === 0) return true;

            const min = typeof params === "object" ? params.min : params;
            const minBytes = min * 1024 * 1024;

            return Array.from(files).every(file => file.size <= minBytes);

        }, "Each file must not exceed the 2MB");


        function extractDomain(text) {
            const match = text.match(/https?:\/\/(www\.)?([a-zA-Z0-9.-]+\.[a-z]{2,})/);
            if (!match) return null;
            return match[2];
        }

        $.validator.addMethod("checkDomain", function (value, element) {
            const websiteUrl = $('#company_website').val().trim();
            const domain = extractDomain(websiteUrl);
            if (!domain) return false;
            const escapedDomain = domain.replace(/\./g, '\\.');
            const regex = new RegExp('^[a-zA-Z0-9._%+\\-]+@' + escapedDomain + '$', 'i');
            return regex.test(value);
        }, function () {
            const domain = extractDomain($('#company_website').val().trim());
            return 'Email must be from @' + (domain ?? 'your website domain');
        });

        function debounce(func, delay) {
            let timer;
            return function () {
                const context = this;
                const args = arguments;
                clearTimeout(timer);
                timer = setTimeout(() => func.apply(context, args), delay);
            };
        }

        const debouncedValidate = debounce(function (element) {
            $(element).valid();
        }, 500); // 500ms delay


        _self.validator = $(_self.$refs.signupAgent).validate({
            // ignore: ":hidden:not(:visible)",
            ignore: function (index, element) {
                return element.name !== "email_code" && element.name !== "cardElementField" && $(element).is(":hidden");
            },
            onkeyup: function (element) {
                debouncedValidate(element);
            },
            rules: {
                first_name: {
                    required: true,
                    maxlength: 50
                },
                last_name: {
                    required: true,
                    maxlength: 50
                },
                business_email: {
                    required: true,
                    validEmailPattern: true,
                    email: true,
                    maxlength: 100,
                    remote: {
                        url: "/verify/check-email",
                        type: "post",
                        data: {
                            email: function () {
                                return document.querySelector('input[name="business_email"]').value;
                            },
                            '_token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                        }
                    }
                },
                'resident_ids[]': {
                    required: false,
                    maxFileSize: 2   // ✅ pass as plain number instead of object
                },
                email_code: {
                    required: true,
                    minlength: 6,
                    maxlength: 6,
                    email_code_success: true
                },
                password: {
                    required: function () { return $("#password").is(":visible"); },
                    minlength: 8,
                    passwordPattern: true
                },
                password_confirmation: { required: true },
                city: "required",
                cardElementField: "required",
                country: "required",
                company_name: "required",
                company_website: {
                    required: true,
                    validWebsitePattern: true,
                    maxlength: 190
                },
                linkedin_profile: {
                    required: true,
                    maxlength: 190,
                    validWebsitePattern: true,
                    remote: {
                        url: "/verify/check-linkedin_profile",
                        type: "post",
                        data: {
                            '_token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                        }
                    }
                },
            },
            messages: {
                business_email: {
                    required: "This email field is required",
                    email: "Please enter a valid email",
                    validEmailPattern: "Please enter a valid email",
                    remote: "The email has already been taken."
                },
                linkedin_profile: {
                    required: "This linkedin profile field is required",
                    remote: "The linkedin profile has already been taken."
                },
            },
            errorPlacement: (error, element) => {
                let password = element.attr('name') == 'password';
                let password_confirmation = element.attr('name') == 'password_confirmation';
                let confirm_consent_employee = element.attr('name') == 'confirm_consent_employee';
                let confirm_terms_condition = element.attr('name') == 'confirm_terms_condition';
                let email_code = element.attr('name') == 'email_code';
                let business_email = element.attr('name') == 'business_email';

                if (confirm_consent_employee) {
                    error.appendTo(element.siblings(".error-container"));
                } else if (confirm_terms_condition) {
                    error.appendTo(element.siblings(".error-container"));
                } else if (email_code) {
                    error.appendTo(element.parent().siblings(".email_code-error"));
                } else if (password) {
                    error.appendTo(element.parent().siblings(".error-container-password"));
                } else if (business_email) {
                    error.appendTo(element.parent().parent().siblings(".error-container-business_email"));
                } else if (password_confirmation) {
                    error.appendTo(element.parent().siblings(".error-container-confirm"));
                } else {
                    error.insertAfter(element);
                }
            },
            submitHandler: async function (form, event) {
                event.preventDefault();

                let formData = new FormData(form);
                if (!_self.cardConfirmed) {
                    _self.isLoading = true;
                    _self.loader(true, 'card', 'Processing...');
                    const firstName = document.getElementById('first_name').value;
                    const lastName = document.getElementById('last_name').value;
                    const email = document.getElementById('business_email').value;
                    // 1. Create payment method FIRST
                    const { setupIntent, error } = await _self.stripe.confirmCardSetup(
                        props.clientSecret,
                        {
                            payment_method: {
                                card: _self.cardElement,
                                billing_details: {
                                    name: `${firstName} ${lastName}`,
                                    email: email,
                                    address: {
                                        line1: document.getElementById('address_line1').value,
                                        city: document.getElementById('address_city').value,
                                        country: document.getElementById('address_country').value,
                                    }
                                }
                            }
                        }
                    );

                    if (error) {
                        _self.isLoading = false;
                        _self.loader(false);
                        _self.cardElementError = error.message;
                        return;
                    }

                    _self.cardConfirmed = true;
                    _self.payment_method_id = setupIntent.payment_method;
                }
                formData.append('payment_method_id', _self.payment_method_id);
                formData.append('payment_cycle', _self.paymentCycle);
                if (_self.isSplit) {
                    formData.append('split_in', _self.plan.contract_months);
                }
                if (_self.splitPriceArray.length > 0) {
                    _self.splitPriceArray.forEach((item, index) => {
                        formData.append(`installments[${index}][date]`, item.only_date);
                        formData.append(`installments[${index}][full_date]`, item.full_date);
                        formData.append(`installments[${index}][referralDiscount]`, index < _self.plan.free_trial_months ? 0 : item.referralDiscount);
                        formData.append(`installments[${index}][freeMonthDiscount]`, index < _self.plan.free_trial_months ? 0: item.freeMonthDiscount);
                        formData.append(`installments[${index}][tax]`, item.tax);
                        formData.append(`installments[${index}][amount]`, item.amountWithoutCurrency);
                    });
                }

                await $.ajax({
                    url: $(form).attr('action'),
                    method: "POST",
                    data: formData,
                    contentType: false,
                    processData: false,
                    beforeSend: function () {
                        _self.isLoading = true;
                        _self.loader(true, 'form', 'Submitting...');
                        // $("button[type='submit']").text("Submitting...");
                    },
                    success: async function (response) {
                        // $("button[type='submit']").text("Submitting...");
                        // ── TASK 5.2: capture the user id for the reference number
                        _self.submittedUserId = response.user?.id ?? null;
                        _self.submittedUserFormattedId = response?.formatted_agent_id ?? null;
                        _self.submitted = true;
                        _self.isLoading = false;
                        form.reset();
                        _self.resetCardForm();
                        _self.validator.resetForm();
                    },
                    error: function (error) {
                        if (error.status === 422) {
                            let targetStep = null;
                            let step1Fields = ['first_name', 'last_name', 'business_email', 'email_code'];
                            let step2Fields = ['password', 'password_confirmation', 'resident_ids.0', 'company_name', 'company_website', 'country_id', 'state_id', 'city_name', 'office_address'];

                            let serverErrors = error.responseJSON.errors;
                            let visibleErrors = {};
                            let unmatchedErrors = {}; // errors with no DOM input to attach to

                            Object.keys(serverErrors).forEach(field => {
                                const baseField = field.split('.')[0];

                                // Check if a DOM element exists for this field
                                // Try both exact name and array-style name (e.g. resident_ids[])
                                const el = _self.validator.currentForm.querySelector(
                                    `[name="${field}"], [name="${baseField}[]"], [name="${baseField}[${field.split('.')[1]}]"]`
                                );

                                if (el) {
                                    visibleErrors[field] = serverErrors[field];
                                } else {
                                    // Collect unmatched errors to show manually (e.g. in a notice box)
                                    unmatchedErrors[baseField] = unmatchedErrors[baseField] || [];
                                    unmatchedErrors[baseField].push(...serverErrors[field]);
                                }

                                // Step detection always uses base field
                                if (step1Fields.includes(baseField) && targetStep === null) targetStep = 0;
                                if (step2Fields.includes(baseField) && targetStep === null) targetStep = 1;
                            });

                            // Only pass errors that have a real DOM element
                            if (Object.keys(visibleErrors).length) {
                                _self.validator.showErrors(visibleErrors);
                            }

                            // Show unmatched errors (like file upload errors) in a fallback notice
                            if (Object.keys(unmatchedErrors).length) {
                                Object.keys(unmatchedErrors).forEach(field => {
                                    const messages = unmatchedErrors[field].join('<br>');
                                    // Option 1: find a manual error container next to the input
                                    const container = document.querySelector(`[data-error-for="${field}"]`);
                                    if (container) {
                                        container.innerHTML = messages;
                                        container.style.display = 'block';
                                    }
                                    // Option 2: fallback — show in a general alert box
                                });
                            }

                            if (targetStep !== null) _self.currentStep = targetStep;
                        }
                    },
                    complete: function () {
                        _self.isLoading = false;
                        _self.loader(false);
                    }
                });

                return false;
            }
        });

        this.$nextTick(() => { _self.getCountries(); });

        this.$watch('states', (newVal) => {
            if (newVal.length > 0) {
                $(this.$refs.signupAgent).valid();
            }
        });
    },

    resetCardForm() {
        if (this.cardElement) { this.cardElement.clear(); }
        $('input[name="cardElementField"]').val('');
        this.cardElementError = '';
    },

    getCountries() {
        axios.get('/api/local/countries/null', {
            params: { search: 'United Arab Emirates' }
        }).then((result) => {
            this.countries = result.data.results;
        }).catch((error) => {
            this.countries = [];
            console.log(error);
        });
    },

    async fetchStates(id) {
        await axios.get(`/api/local/states`, { params: { 'country_id': id } })
            .then((result) => { this.states = result.data.results; })
            .catch((error) => { this.states = []; });
    },
}));


Alpine.data('dateRangePicker', (config = {}) => ({
    key: null,

    init() {
        this.key = this.$el.id;

        const options = {
            opens: "left",
            drops: "auto",
            singleDatePicker: true,
            autoUpdateInput: true,
            showDropdowns: true,
            autoApply: true,
            showCancel: true,
            applyButtonClasses: "btn bg-primary text-white",
            locale: {
                format: 'DD/MM/YYYY',
                cancelLabel: 'Clear',
                applyLabel: 'Select'
            },
            ...config // allow overrides
        };

        // init jQuery plugin
        $(this.$el).daterangepicker(options, (start, end) => {
            console.log(start);

            // Alpine-friendly event
            this.$dispatch('date-selected', {
                start,
                end
            });
        });

        // Handle clear button manually
        $(this.$el).on('cancel.daterangepicker', (ev, picker) => {
            $(this.$el).val('');
            this.$dispatch('date-cleared');
        });
    }
}));
